// @flow
import { PRODUCT_EXCLUSIVE_COLLECTION_SPACE } from 'Client/cms/toolkit/constants';
import { ProductExclusiveCollectionSpaceLine } from 'Components/lines/product-exclusive-collection-space-line/ProductExclusiveCollectionSpaceLine.jsx';
import { productExclusiveCollectionSpaceResolver } from './productExclusiveCollectionSpace.resolver';

export const productExclusiveCollectionSpaceDescriptor = {
  name: PRODUCT_EXCLUSIVE_COLLECTION_SPACE,
  component: ProductExclusiveCollectionSpaceLine,
  resolver: productExclusiveCollectionSpaceResolver.resolve,
};
